import React, { useState } from 'react';
import Filter from '../../Filter/Filter';

interface AtlasFiltersProps {
    filterOptions: any[]; // Replace 'any' with the appropriate type if known
    onFilterChange: (options: any[]) => void; // Replace 'any' with the appropriate type if known
}

const AtlasFilters: React.FC<AtlasFiltersProps> = ({ filterOptions, onFilterChange }) => {
    const [selectedOptions, setSelectedOptions] = useState<any[]>([]);

    const handleFilterChange = (options: any[]) => {
        setSelectedOptions(options);
        onFilterChange(options);
    };

    return (
        <div className="atlas-filters">
            <Filter options={filterOptions} selectedOptions={selectedOptions} onChange={handleFilterChange} />
        </div>
    );
};

export default AtlasFilters;
